import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Section } from '@/components/Section';
import { Button } from '@/components/ui/button';

export function HomeFeaturedSection() {
  return (
    <Section>
      <motion.div
        className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border border-primary/20 rounded-2xl p-8 md:p-10 overflow-hidden"
        initial={{ opacity: 0.5, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        data-testid="aiw-homepage-promo"
      >
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
        <div className="relative z-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-1">
            <span className="text-xs font-semibold text-primary uppercase tracking-widest mb-2 block">Featured Presentation</span>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">The AI Whisperer</h2>
            <p className="text-slate-400 leading-relaxed mb-5">
              A live, interactive presentation that helps non-technical audiences understand AI in practical, meaningful ways. Ideal for businesses, schools, and community organizations.
            </p>
            <div className="flex flex-wrap gap-3">
              <Button asChild className="bg-primary text-white hover:text-white hover:bg-primary/80 shadow-[0_4px_0_0_rgba(168,130,20,1)] hover:shadow-[0_2px_0_0_rgba(168,130,20,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100" data-testid="aiw-promo-explore-btn">
                <Link to="/ai-whisperer">Explore the Presentation</Link>
              </Button>
              <a
                href="https://substack.com/@youraiwhisperer"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 border border-slate-600 text-slate-300 hover:text-white hover:bg-slate-800 rounded-md px-5 py-2 transition-colors"
                data-testid="aiw-promo-substack-btn"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6"><path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/></svg>
                <span className="text-sm font-semibold">Subscribe on Substack</span>
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-full md:w-auto md:max-w-[420px] lg:max-w-[510px]" style={{ perspective: '800px' }}>
            <img
              src="/assets/full-stage-keynote.jpg"
              alt="R. Dale Brunet delivering The AI Whisperer keynote on stage"
              className="w-full rounded-xl shadow-[0_20px_50px_rgba(0,0,0,0.5),0_0_0_1px_rgba(255,255,255,0.05)] transition-transform duration-300 hover:scale-[1.02]"
              style={{ transform: 'rotateY(-4deg) rotateX(2deg)', transformStyle: 'preserve-3d' }}
            />
          </div>
        </div>
      </motion.div>
    </Section>
  );
}
